import { getRequiredTableNames } from '../source/required-csv-files';
import { PracticeWorksSourceHandler } from './source';

export function getPracticeWorksExportTableNames(): string[] {
  return getRequiredTableNames(
    new PracticeWorksSourceHandler().entityHandlers
  ).sort();
}
